import { GroupedAutocompleteGroups } from './GroupedAutocompleteGroups';
import { GroupedAutocompleteItems } from './GroupedAutocompleteItems';
import { GroupedAutocompleteRoot } from './GroupedAutocompleteRoot';

export type { GroupedAutocompleteItem } from './types';

export const GroupedAutocomplete = {
  Root: GroupedAutocompleteRoot,
  Groups: GroupedAutocompleteGroups,
  Items: GroupedAutocompleteItems,
};
